import {
  Tooltip,
  TooltipProps,
  NavLink,
  useComputedColorScheme,
  useMantineTheme,
} from '@mantine/core';
import { useIsExistAuthentication } from '@refinedev/core';
import { useTranslation } from '@refinedev/core';
import { IconLogout } from '@tabler/icons-react';
import { useLogout } from 'hooks/useLogout';
import { Link } from 'react-router-dom';
import { useSettingsStore } from 'store/SettingsStore';

// Sentry
import * as Sentry from '@sentry/react';

interface LogoutNavLinkProps {
  isCollapsed: boolean;
  mobileSiderOpen: boolean;
  commonNavLinkStyles: any;
  commonToolTipProps: Partial<TooltipProps>;
}

export const LogoutNavLink: React.FC<LogoutNavLinkProps> = ({
  isCollapsed,
  mobileSiderOpen,
  commonNavLinkStyles,
  commonToolTipProps,
}) => {
  const isExistAuthentication = useIsExistAuthentication();
  const handleLogout = useLogout();
  const theme = useMantineTheme();
  const { markUnsynced } = useSettingsStore();
  const computedColorScheme = useComputedColorScheme('dark');
  const { translate } = useTranslation();
  const logoutLabel = translate('buttons.logout');

  if (!isExistAuthentication) {
    return null;
  }

  return (
    <Tooltip label={logoutLabel} {...commonToolTipProps}>
      <NavLink
        key="logout"
        label={isCollapsed && !mobileSiderOpen ? null : logoutLabel}
        leftSection={
          <IconLogout
            size={20}
            style={{
              color: theme.colors[`red-${computedColorScheme}`][0],
            }}
          />
        }
        pl={isCollapsed || mobileSiderOpen ? '0.75rem' : '1.125rem'}
        onClick={() => {
          markUnsynced();
          handleLogout();
          Sentry.setUser(null);
        }}
        component={Link}
        to={'/login'}
        data-testid="logout-nav-link"
        styles={{
          ...commonNavLinkStyles,
          label: {
            ...(commonNavLinkStyles?.label || {}),
            color: theme.colors[`red-${computedColorScheme}`][0],
          },
          root: {
            ...(commonNavLinkStyles?.root || {}),
            marginTop: '0.75rem',
            '&:hover': {
              color: theme.colors[`red-${computedColorScheme}`][0],
            },
          },
        }}
      />
    </Tooltip>
  );
};
